<article class="mandate-actions">
  <section class="header">
    <h1>{{ 'COMMON.MANDATE-ACTIONS' | translate }}</h1>
  </section>

  <section class="content">
    <article>
      <p class="message" [innerHTML]="'MANDATE-ACTIONS.ACTIONS-AWAITING' | translate: { count }"></p>

      <section class="actions" *ngIf="count && count > 0">
        <button (click)="handleReject()" mat-flat-button color="warn">
          <mat-icon fontSet="material-symbols-outlined">cancel</mat-icon>
          {{ 'BUTTON.REJECT' | translate }}
        </button>
        <button (click)="handleApprove()" mat-flat-button class="accept">
          <mat-icon fontSet="material-symbols-outlined">check_circle</mat-icon>
          {{ 'BUTTON.APPROVE' | translate }}
        </button>
      </section>

    </article>
  </section>
</article>
